import React, { Fragment, FunctionComponent, useEffect } from 'react';
import styles from './TcmMedicalInfo.Styles';
import { Grid } from '@material-ui/core';
import { EmptyDataLabel } from '../../../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import TcmMedicalInfoEntity from '../../../../../../entities/tcm/TcmMedicalInfo.Entity';
import { TooltipTextField } from '../../../../../generic-components/tooltip-textfield/TooltipTextField.Component';
import Moment from 'moment';

interface ITcmMedicalInfoProps {
    referralId: number;
    tcmMedicalInfo?: TcmMedicalInfoEntity;
    handleTcmMedicalInfoEdit: (edit: TcmMedicalInfoEntity) => void;
}

export const TcmMedicalInfo: FunctionComponent<ITcmMedicalInfoProps> = (props: ITcmMedicalInfoProps) => {
    const classes = styles();

    const [tcmMedicalInfoState, setTcmMedicalInfoState] = React.useState<TcmMedicalInfoEntity>(
        props.tcmMedicalInfo || { referralId: props.referralId }
    );

    useEffect(() => {
        if (props.tcmMedicalInfo) {
            setTcmMedicalInfoState(props.tcmMedicalInfo);
        }
    }, [props.tcmMedicalInfo]);

    const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        let newMedicalInfo: TcmMedicalInfoEntity = { ...tcmMedicalInfoState };
        if (!newMedicalInfo.referralId) {
            newMedicalInfo.referralId = props.referralId;
        }

        newMedicalInfo[event.target.id || event.target.name] = event.target.value;

        setTcmMedicalInfoState(newMedicalInfo);
        props.handleTcmMedicalInfoEdit(newMedicalInfo);
    };

    return (
        <Fragment>
            {tcmMedicalInfoState ? (
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={6}>
                        <TooltipTextField
                            type="date"
                            id="surgeryDate"
                            name="surgeryDate"
                            label="Surgery Date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={
                                tcmMedicalInfoState?.surgeryDate
                                    ? Moment(tcmMedicalInfoState?.surgeryDate)?.format('YYYY-MM-DD')
                                    : ''
                            }
                            onChange={handleTextFieldChange}
                            style={{ width: 200 }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TooltipTextField
                            label="Primary Diagnosis"
                            id="primaryDiagnosis"
                            value={tcmMedicalInfoState?.primaryDiagnosis || ''}
                            onChange={handleTextFieldChange}
                            inputProps={{ maxLength: 250 }}
                        />
                    </Grid>
                    
                </Grid>
            ) : (
                <EmptyDataLabel />
            )}
        </Fragment>
    );
};

